import { docReady } from '../utils/docReady';
const transparentHeaderSelectors = {
    trigger: '[data-transparent-header-trigger]',
};
const init = () => {
    const transparentTriggers = document.querySelectorAll(transparentHeaderSelectors.trigger);
    const header = document.querySelector('.header');
    if (transparentTriggers && transparentTriggers.length > 0) {
        const bodyElement = document.querySelector('body');
        const notificationBar = document.querySelector('.notification-bar');
        let topBuffer = 0;
        if (notificationBar) {
            const barBounding = notificationBar.getBoundingClientRect();
            const headerBounding = header.getBoundingClientRect();
            topBuffer = barBounding.height;
            topBuffer += headerBounding.height;
        }
        bodyElement.classList.add('header-style--transparent');
        window.addEventListener('scroll', () => {
            let show = true;
            transparentTriggers.forEach((trigger) => {
                const bounding = trigger.getBoundingClientRect();
                let boundingHeight = bounding.height * -1 + topBuffer;
                if (bounding.y >= boundingHeight && bounding.y <= topBuffer) {
                    show = false;
                }
            });
            if (show) {
                bodyElement.classList.add('header-style--scrolled');
            }
            else {
                bodyElement.classList.remove('header-style--scrolled');
            }
        });
    }
};
docReady(init());
